import { HospitalScheduleTemplateModel } from "@common/models";
import { HospitalScheduleTemplateRequest } from "@common/models/requests";
import { HospitalService } from "@common/services";
import { NotificationStoreInstance } from "@common/stores";
import { flow, makeAutoObservable } from "mobx";


export class HospitalScheduleTemplateStore {
    private _hospitalScheduleTemplate: HospitalScheduleTemplateModel | undefined;
    isHospitalScheduleTemplateLoading: boolean = false;
    isSaving: boolean = false;

    constructor() {
        makeAutoObservable(this, undefined, { autoBind: true });
    }

    get hospitalScheduleTemplate() {
        return this._hospitalScheduleTemplate;
    }

    set hospitalScheduleTemplate(value: HospitalScheduleTemplateModel | undefined) {
        this._hospitalScheduleTemplate = value;
    }

    clearHospitalScheduleTemplate() {
        this.isHospitalScheduleTemplateLoading = true;
        this.isSaving = false;
        this.hospitalScheduleTemplate = undefined;
        this.isHospitalScheduleTemplateLoading = false;
    }

    loadHospitalScheduleTemplate = flow(function* (this: HospitalScheduleTemplateStore, hospitalScheduleTemplateId: number) {
        this.isHospitalScheduleTemplateLoading = true;
        this._hospitalScheduleTemplate = undefined;
        this._hospitalScheduleTemplate = yield HospitalService.getHospitalScheduleTemplate(hospitalScheduleTemplateId);
        this.isSaving = false;
        this.isHospitalScheduleTemplateLoading = false;
    });

    saveHospitalScheduleTemplate = flow(function* (this: HospitalScheduleTemplateStore, templateRequest: HospitalScheduleTemplateRequest) {
        this.isSaving = true;
        this._hospitalScheduleTemplate = undefined;
        const successMessage = `Successfully ${templateRequest.hospitalScheduleTemplateId === 0 ? 'created' : 'updated'} schedule template: ${templateRequest.name}`;
        const errorMessage = `Failed to ${templateRequest.hospitalScheduleTemplateId === 0 ? 'create' : 'update'} schedule template: ${templateRequest.name}`;

        this._hospitalScheduleTemplate = yield HospitalService.updateHospitalScheduleTemplate(templateRequest)
            .then(NotificationStoreInstance.onSuccess(successMessage))
            .catch(NotificationStoreInstance.onError(errorMessage, undefined));
        this.isSaving = false;
    });
}
